import { Routes, Route, useLocation } from 'react-router-dom'
import { AnimatePresence, motion } from 'framer-motion'
import { Helmet } from 'react-helmet-async'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import AnimatedBackground from './components/AnimatedBackground'
import Home from './pages/Home'
import ResearchPapers from './pages/ResearchPapers'
import SocialMedia from './pages/SocialMedia'
import OwnAlgorithms from './pages/OwnAlgorithms'
import AlgorithmDetail from './pages/AlgorithmDetail'

const pageTransition = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -12 },
  transition: { duration: 0.5, ease: [0.25, 0.46, 0.45, 0.94] }
}

function App() {
  const location = useLocation()

  return (
    <div className="min-h-screen bg-ink text-cream relative overflow-x-hidden">
      <Helmet>
        <title>QuantAlgoLabs — Research Papers, Platform Algorithms, Proprietary Code</title>
        <meta name="description" content="QuantAlgoLabs transforms cutting-edge research papers and social media algorithms into production-ready code with full documentation, GitHub references, and live demos." />
        <link rel="canonical" href={`https://quantalgolabs.org${location.pathname}`} />
      </Helmet>

      <AnimatedBackground />
      <Navbar />

      <AnimatePresence mode="wait">
        <motion.main
          key={location.pathname}
          {...pageTransition}
          className="relative z-10"
        >
          <Routes location={location}>
            <Route path="/" element={<Home />} />
            <Route path="/archive" element={<ResearchPapers />} />
            <Route path="/decode" element={<SocialMedia />} />
            <Route path="/forge" element={<OwnAlgorithms />} />
            <Route path="/algorithm/:id" element={<AlgorithmDetail />} />
          </Routes>
        </motion.main>
      </AnimatePresence>

      <Footer />
    </div>
  )
}

export default App
